export default "__VITE_ASSET__DI3Bj_yn__"